const WrongAddress=()=>{
    return (<div>
        <h2>Address is not valid</h2>
    </div>);
};
export default WrongAddress;